import dayjs from 'dayjs';
import { dayMonthTextFormat } from '@hefe/utils';
import styles from './event-date-box.component.module.scss';

export interface EventDateBoxComponentProps {
    date: string;
}

export default function EventDateBoxComponent(props: EventDateBoxComponentProps) {

    const date = dayjs(props.date);

  return(
    <div className={styles['dateBox']}>
    <span className={styles['dayOfWeek']}>
      {date.format('ddd')}
    </span>
    <span className={styles['date']}>
      {date.format(dayMonthTextFormat())}
    </span>
  </div>
  );
}
